/**
 * TanStack Query yapılandırması.
 *
 * ─── 4xx YENİDEN DENENMEZ ────────────────────────────────────────────────────
 * Varsayılan davranış her hatayı 3 kez tekrarlar. "Yetkiniz yok" veya
 * "geçersiz gövde" cevabını tekrarlamak anlamsızdır: sonuç değişmeyecek, ama
 * kullanıcı üç kat bekleyecek ve sunucu boşuna yorulacak. Bu, toplayıcıdaki
 * KALICI / GEÇİCİ hata ayrımının [K-016] arayüzdeki karşılığı.
 *
 * ─── ODAKTA YENİDEN GETİRME KAPALI ───────────────────────────────────────────
 * Sekmeye her dönüşte tüm sorguları tazelemek mobilde veri ve pil yakar.
 * Canlı olması gereken veri (tank değerleri) SSE ile gelecek (Görev 7);
 * geri kalanı kullanıcı isteğiyle tazelenir.
 */
import { QueryClient } from '@tanstack/react-query';

import { ApiError, NetworkError } from './api.ts';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (denemeSayisi, error) => {
          // Ağ yoksa birkaç kez dene — mobilde tünelden çıkmak bunu çözer.
          if (error instanceof NetworkError) return denemeSayisi < 2;
          // 4xx KALICI: tekrar denemek sonucu değiştirmez.
          if (error instanceof ApiError && error.status < 500) return false;
          return denemeSayisi < 2;
        },
        // Veriyi 30 sn taze say — aynı ekranda gezinirken tekrar istek atma.
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Yazma işlemi ASLA otomatik tekrarlanmaz: mükerrer kayıt riski.
        retry: false,
      },
    },
  });
}
